import { c as _c } from "react/compiler-runtime";
import Tooltip from '@/components/modules/Tooltip';
import useCartLoading from '@/contexts/cartContext/hooks/useCartLoading';
import useCartRemoveDiscount from '@/contexts/cartContext/hooks/useCartRemoveDiscount';
import useCurrency from '@/contexts/i18nContext/hooks/useCurrency';
import useTranslate from '@/contexts/i18nContext/hooks/useTranslate';
import { Button } from '@winelidays/wld-tsx-2/elements';
import { DiscountTagIcon, InfoIcon } from '@winelidays/wld-tsx-2/images';
import { capitalize, formatPrice } from '@winelidays/wld-tsx-2/utils';
import { useEffect, useState } from 'react';
const DiscountContent = t0 => {
    const $ = _c(34);
    const { totalDiscount, discountUnusedAmount } = t0;
    const translate = useTranslate();
    const { symbol: currencySymbol } = useCurrency();
    const loadingCart = useCartLoading();
    const removeDiscount = useCartRemoveDiscount();
    let t1;
    if ($[0] !== translate) {
        t1 = capitalize(translate("messages.discount_code"));
        $[0] = translate;
        $[1] = t1;
    }
    else {
        t1 = $[1];
    }
    const discountCodeLabel = t1;
    let t2;
    if ($[2] !== translate) {
        t2 = translate("messages.delete");
        $[2] = translate;
        $[3] = t2;
    }
    else {
        t2 = $[3];
    }
    const deleteButtonLabel = t2;
    const discountAmount = `-${translate("messages.price_with_currency", {
        price: formatPrice(totalDiscount),
        currencySymbol
    })}`;
    const [wasClicked, setWasClicked] = useState(false);
    let t3;
    if ($[4] !== removeDiscount) {
        t3 = () => {
            setWasClicked(true);
            removeDiscount();
        };
        $[4] = removeDiscount;
        $[5] = t3;
    }
    else {
        t3 = $[5];
    }
    const handleDeleteClick = t3;
    let t4;
    let t5;
    if ($[6] !== loadingCart) {
        t4 = () => {
            if (!loadingCart) {
                setWasClicked(false);
            }
        };
        t5 = [loadingCart];
        $[6] = loadingCart;
        $[7] = t4;
        $[8] = t5;
    }
    else {
        t4 = $[7];
        t5 = $[8];
    }
    useEffect(t4, t5);
    let t6;
    if ($[9] !== currencySymbol || $[10] !== discountUnusedAmount || $[11] !== totalDiscount || $[12] !== translate) {
        t6 = translate("cart_page.discount_content.usage_info.remainder_on_site", {
            used: formatPrice(totalDiscount),
            unused: formatPrice(discountUnusedAmount),
            currencySymbol
        });
        $[9] = currencySymbol;
        $[10] = discountUnusedAmount;
        $[11] = totalDiscount;
        $[12] = translate;
        $[13] = t6;
    }
    else {
        t6 = $[13];
    }
    const tooltipContent = t6;
    let t7;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = <DiscountTagIcon className="mr-1 xs:mr-2"/>;
        $[14] = t7;
    }
    else {
        t7 = $[14];
    }
    let t8;
    if ($[15] !== discountAmount) {
        t8 = <span className="mx-2 font-bold whitespace-nowrap">{discountAmount}</span>;
        $[15] = discountAmount;
        $[16] = t8;
    }
    else {
        t8 = $[16];
    }
    let t9;
    if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = <span data-dispo={true} className="text-gray-400 text-opacity-50 mb-0.5" tabIndex={-1}><InfoIcon /></span>;
        $[17] = t9;
    }
    else {
        t9 = $[17];
    }
    let t10;
    if ($[18] !== t8) {
        t10 = <button className="inline-flex flex-row items-center">{t8}{t9}</button>;
        $[18] = t8;
        $[19] = t10;
    }
    else {
        t10 = $[19];
    }
    let t11;
    if ($[20] !== t10 || $[21] !== tooltipContent) {
        t11 = <Tooltip content={tooltipContent}>{t10}</Tooltip>;
        $[20] = t10;
        $[21] = tooltipContent;
        $[22] = t11;
    }
    else {
        t11 = $[22];
    }
    let t12;
    if ($[23] !== discountCodeLabel || $[24] !== t11) {
        t12 = <p className="inline-flex items-center">{t7}{discountCodeLabel}{t11}</p>;
        $[23] = discountCodeLabel;
        $[24] = t11;
        $[25] = t12;
    }
    else {
        t12 = $[25];
    }
    const t13 = !wasClicked;
    let t14;
    if ($[26] !== deleteButtonLabel || $[27] !== handleDeleteClick || $[28] !== loadingCart || $[29] !== t13) {
        t14 = <Button title={deleteButtonLabel} onClick={handleDeleteClick} className="btn-ghost-primary !text-xs -mr-2" busy={loadingCart} hideBusyWheel={t13}>{deleteButtonLabel}</Button>;
        $[26] = deleteButtonLabel;
        $[27] = handleDeleteClick;
        $[28] = loadingCart;
        $[29] = t13;
        $[30] = t14;
    }
    else {
        t14 = $[30];
    }
    let t15;
    if ($[31] !== t12 || $[32] !== t14) {
        t15 = <div className="flex flex-row justify-between items-center">{t12}{t14}</div>;
        $[31] = t12;
        $[32] = t14;
        $[33] = t15;
    }
    else {
        t15 = $[33];
    }
    return t15;
};
export default DiscountContent;
